import {Component, EventEmitter, Output} from '@angular/core';
import { HostListener } from '@angular/core';

@Component({
  selector: 'sg-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

  @Output() landingChange = new EventEmitter();
  showInfo = false;

  // SCHERMGROOTTE BEPALEN
  scrHeight:any;
  scrWidth:any;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    console.log(this.scrHeight, this.scrWidth);
  }

  constructor() {
    this.getScreenSize();
  }

}
